import { NgModule } from '@angular/core';
import { ChartsModule } from 'ng2-charts';

import { ChartMuaHangComponent } from './chart-mua-hang.component';

@NgModule({
  imports:      [ ChartsModule ],
  declarations: [ ChartMuaHangComponent ],
  bootstrap:    [ ChartMuaHangComponent ],
  exports: [
    ChartMuaHangComponent
]
})
export class ChartMuaHangModule { }
